import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影频道", to: "/category/movie" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "综艺频道", to: "/category/variety" },
  { label: "搜索影视", to: "/search" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-background-200/60 bg-background-100">
      <div className="grid grid-cols-1 gap-8 px-4 py-12 md:grid-cols-4 md:px-8">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-play-fill text-lg" />
            </span>
            <span className="font-heading text-lg font-600 tracking-wide text-foreground-950">
              91<span className="text-accent-500">在线视频</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-500">
            91在线视频是聚焦高清影视内容的在线视频平台，汇聚电影、电视剧及综艺节目，
            致力于为影视爱好者提供便捷、丰富、清晰的观影与浏览体验。本站为前端演示站点，
            所有内容仅供展示。
          </p>
          <div className="mt-4 flex gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:text-accent-500">
              <i className="ri-wechat-line text-lg" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:text-accent-500">
              <i className="ri-weibo-line text-lg" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:text-accent-500">
              <i className="ri-mail-line text-lg" />
            </span>
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-600 uppercase tracking-wider text-foreground-950">
            快速导航
          </h4>
          <ul className="mt-4 space-y-2">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-foreground-600 transition-colors hover:text-accent-500"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-600 uppercase tracking-wider text-foreground-950">
            关于平台
          </h4>
          <ul className="mt-4 space-y-2">
            <li>
              <Link
                to="/about"
                className="text-sm text-foreground-600 transition-colors hover:text-accent-500"
              >
                平台介绍
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className="text-sm text-foreground-600 transition-colors hover:text-accent-500"
              >
                版权声明
              </Link>
            </li>
            <li>
              <Link
                to="/favorites"
                className="text-sm text-foreground-600 transition-colors hover:text-accent-500"
              >
                我的收藏
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-3 border-t border-background-200/60 px-4 py-6 text-xs text-foreground-500 sm:flex-row md:px-8">
        <p>© 2025 91在线视频 · 本站为前端演示站点，内容仅供学习与展示使用。</p>
        <p>免责声明：视频播放、下载、会员等业务均未提供，所有信息不构成任何承诺。</p>
      </div>
    </footer>
  );
}